export function PageHeader({ title, subtitle, action }) {
    return (
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
            <div>
                <h1 className="text-[28px] font-bold tracking-[-0.02em] text-ink lg:text-[32px]">{title}</h1>
                {subtitle && <p className="mt-1 measure text-[15px] leading-[1.6] text-subtle">{subtitle}</p>}
            </div>
            {action}
        </div>
    );
}
